export const envs = {
  "production": true,
  "graphqlUrl": "https://sapi.2026.fbtv3.ir/graphql",
  "s3Url": "https://static.2026.fbtv3.ir/",
  "fbtv3S3Url": "https://s3.fbtv3.ir",
  "apiUrl": "https://sapi.2026.fbtv3.ir",
  "gameWebsiteBaseUrl": "https://game.2026.fbtv3.ir",
  "metrix": {
    "appId": "hqavcaenpgwezar",
    "apiKey": "f1aa44e2-d1f5-4dbe-8f4e-8f3ebc2f8a5f"
  }
};
